import { setStores } from 'Slices/Settings/StoreSlice'
import { createRequest, handleErrorCatchLog } from '../../Helpers/GenericHelpers'
import { getTokenFromSessionStorage } from '../../Helpers/TokenHelper'

const getStores = () => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()
  const stores = state.present.configuration.stores
  if (!state.present.article.serverConfig || !token || !stores) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  return createRequest(`/api/stores/?config=${state.present.article.serverConfig}`, 'GET', undefined, token)
    .then(response => response.json())
    .then(data => {
      dispatch(setStores(data))
    })
    .catch(err => {
      handleErrorCatchLog(err, 'failed on retrieve stores getAllStores')
    })
}

export { getStores }
